

// export const baseUrl = process.env.NODE_ENV == 'production' ? '/' : '/api';

export const baseUrl = process.env.NODE_ENV == 'production' ? 'https://alleatapp.com/base/' : '/api';